import { clsx, type ClassValue } from "clsx";
import { extendTailwindMerge } from "tailwind-merge";

// tailwind-merge has to know SAP's custom theme keys, otherwise it reads `text-xxs` as a color
// or `shadow-card` as a shadow color and drops the wrong class when merging.
const twMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      "font-size": [{ text: ["xxs"] }],
      shadow: [{ shadow: ["xs", "card", "popover", "dialog"] }],
      rounded: [{ rounded: ["control", "card"] }],
    },
  },
});

/** Joins class names and resolves Tailwind conflicts (the last class wins). */
export const cn = (...inputs: ClassValue[]): string => twMerge(clsx(inputs));
